import {API} from '../../../networking/http'
import {MutationMethod} from '../../helpers/types'

export type CreateSubscriptionRequestMutationReturnType = {
  uid?: string
}

export type CreateSubscriptionRequestMutationParams = {}

export type CreateSubscriptionRequestParams = {
  subscriptionId: string
}

export type CreateInstructorBookingMutation = MutationMethod<
  CreateSubscriptionRequestParams,
  CreateSubscriptionRequestMutationParams,
  CreateSubscriptionRequestMutationReturnType
>

export const makeCreateSubscriptionRequestEndpoint = (membershipId?: string) =>
  `memberships/${membershipId}/invitations/createRequest`

export const createSubscriptionRequestMutation: CreateInstructorBookingMutation = ({params}) => ({
  mutationFn: (data) => {
    return API.post<CreateSubscriptionRequestMutationParams, CreateSubscriptionRequestMutationReturnType>(
      makeCreateSubscriptionRequestEndpoint(params?.subscriptionId),
      data,
    ).then((res) => res.data)
  },
})
